var map = {
	"./api-wasm.js": [
		4900
	],
	"./fft01-wasm.js": [
		9849,
		849
	],
	"./fft01unsafe-wasm.js": [
		6254,
		254
	],
	"./fft47-wasm.js": [
		9721,
		721
	],
	"./fft_rust-wasm.js": [
		6368,
		368
	],
	"./wrap-wasm.js": [
		8937
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 60;
module.exports = webpackAsyncContext;